import { useRef, useState } from "react";

import * as S from "./LandingPagePartnerOrganism.style";
import Image from "next/legacy/image";
import { ArrowDropDown20 } from "@/system/day/icon/icon";
import { grayScale } from "@teamsparta/design-system";
export let partnersRef;

const LandingPagePartnerOrganism = () => {
  const [more, setMore] = useState<boolean>(false);
  partnersRef = useRef();
  return (
    <S.Wrapper ref={partnersRef}>
      <S.Title>
        1,000개의 협력사에서
        <br />
        당신을 기다리고 있습니다.
      </S.Title>
      <S.ImageContainer more={more}>
        <S.MobileImageWrapper>
          <Image
            src={`${process.env.CDN_BASE_URL}/files/intellipick/image/landing/partner_companies_mobile.png`}
            width={360}
            height={288}
            quality={100}
            alt={"모바일 협력사 명단"}
          />
        </S.MobileImageWrapper>
        <S.WebImageWrapper>
          <Image
            src={`${process.env.CDN_BASE_URL}/files/intellipick/image/landing/partner_companies_web.png`}
            width={1016}
            height={210}
            quality={100}
            alt={"데스크탑 협력사 명단"}
          />
        </S.WebImageWrapper>
        {!more && <S.Gradation />}
      </S.ImageContainer>
      {!more && (
        <S.MoreCta onClick={() => setMore(true)}>
          더보기 <ArrowDropDown20 color={grayScale.gray90} />
        </S.MoreCta>
      )}
    </S.Wrapper>
  );
};

export default LandingPagePartnerOrganism;
